export default {
  options: (data, localeRoot) => {
    if (!data || data.length === 0) return null

    return {
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      tooltip: {
        trigger: 'axis',
        backgroundColor: '#212529',
        borderColor: '#212529',
        textStyle: {
          color: 'rgba(255, 255, 255, 1)',
          fontFamily: 'Montserrat'
        },
        formatter: params => {
          let text = `${params[0].axisValue}<br/>`

          params.forEach(serie => {
            text += Vue.i18n.t(
              `${localeRoot}.tooltip`,
              {
                color: serie.color,
                name: serie.seriesName,
                data: Vue.filter('floatRepresentation')(serie.data || '-')
              }
            )
          })

          return text
        }
      },
      xAxis: [
        {
          type: 'category',
          data: data.map(item => item.date),
          axisLabel: {
            rotate: 30,
            margin: 28.5,
            align: 'center',
            // Se añaden espacios al principio para que el ZoomSlider no se superponga
            // No encuentro forma de hacerlo con la configuración
            formatter: value => `        ${value.replace(/\/\d{4}$/, '')}`
          },
          axisTick: {
            alignWithLabel: true
          }
        }
      ],
      yAxis: [
        {
          type: 'value'
        }
      ],
      series: [
        {
          name: Vue.i18n.t(`${localeRoot}.series.totalCount`),
          type: 'line',
          data: data.map(item => item.totalCount),
          smooth: true
        },
        {
          name: Vue.i18n.t(`${localeRoot}.series.convertedCount`),
          type: 'line',
          data: data.map(item => item.convertedCount),
          smooth: true
        },
        {
          name: Vue.i18n.t(`${localeRoot}.series.cpa`),
          type: 'line',
          data: data.map(item => item.cpa),
          smooth: true
        }
      ],
      dataZoom: [
        {
          id: 'dataZoomX',
          type: 'slider',
          xAxisIndex: [0],
          filterMode: 'empty',
          showDetail: false,
          brushSelect: false
        }
      ],
      legend: {
        textStyle: {
          fontFamily: 'Montserrat'
        },
        data: [
          Vue.i18n.t(`${localeRoot}.series.totalCount`),
          Vue.i18n.t(`${localeRoot}.series.convertedCount`),
          Vue.i18n.t(`${localeRoot}.series.cpa`)
        ],
        top: '3%'
      },
      media: [
        {
          query: {
            maxWidth: 500
          },
          option: {
            title: {
              textStyle: {
                fontSize: 14,
                fontStyle: 'normal',
                fontWeight: 'normal',
                overflow: 'break',
                width: 270
              }
            }
          }
        }
      ],
      color: GRAPH_COLORS
    }
  }
}
